import { customFetch } from "@/client/custom-fetch";

import {
  TDashboardChartRequest,
  TDashboardChartResponse,
  TDashboardOverviewRequest,
  TDashboardOverviewResponse,
  TDashboardRankingRequest,
  TPlansRankingResponse,
  TProductsRankingResponse,
} from "./dashboard.types";

const API_BASE = "/sales/dashboard";

export const dashboardApi = {
  getProductTypes: async (): Promise<string[]> => {
    return customFetch<string[]>(`${API_BASE}/product-types`, {
      method: "GET",
      skipLoading: true,
    });
  },

  getOverview: async (
    params: TDashboardOverviewRequest
  ): Promise<TDashboardOverviewResponse> => {
    // Monta o objeto de filtro como JSON
    const filterObj: { type_product?: string; period?: string | number } = {};
    
    // Se o período for "total", não envia o período no filtro
    // Caso contrário (quando for número), sempre envia o período como string (backend espera string)
    if (params.period !== "total") {
      filterObj.period = String(params.period);
    }
    
    // Se for diferente de "all", adiciona o type_product no filtro
    if (params.type_product && params.type_product !== "all") {
      filterObj.type_product = params.type_product;
    }
    
    // Constrói a URL com query parameter filters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filterObj));
    
    const url = `${API_BASE}/overview?${queryParams.toString()}`;
    
    return customFetch<TDashboardOverviewResponse>(url, {
      method: "GET",
      skipLoading: true,
    });
  },
  
  getProductsRanking: async (
    params: TDashboardRankingRequest
  ): Promise<TProductsRankingResponse> => {
    // Monta o objeto de filtro como JSON (seguindo exatamente o mesmo padrão do getOverview)
    const filterObj: { type_product?: string; period?: string | number } = {};
    
    // Se o período for "total", não envia o período no filtro
    // Caso contrário (quando for número), sempre envia o período como string (backend espera string)
    if (params.period !== undefined && params.period !== "total") {
      filterObj.period = String(params.period);
    }
    
    // Se for diferente de "all", adiciona o type_product no filtro
    if (params.type_product && params.type_product !== "all") {
      filterObj.type_product = params.type_product;
    }
    
    // Constrói a URL com query parameter filters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filterObj));
    
    const url = `${API_BASE}/products/ranking?${queryParams.toString()}`;
    
    return customFetch<TProductsRankingResponse>(url, {
      method: "GET",
      skipLoading: true,
    });
  },
  
  getPlansRanking: async (
    params: { period?: number | "total" }
  ): Promise<TPlansRankingResponse> => {
    // Monta o objeto de filtro como JSON (seguindo exatamente o mesmo padrão do getOverview)
    const filterObj: { period?: string | number } = {};
    
    // Se o período for "total", não envia o período no filtro
    // Caso contrário (quando for número), sempre envia o período como string (backend espera string)
    if (params.period !== undefined && params.period !== "total") {
      filterObj.period = String(params.period);
    }
    
    // Constrói a URL com query parameter filters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filterObj));
    
    const url = `${API_BASE}/plans/ranking?${queryParams.toString()}`;
    
    return customFetch<TPlansRankingResponse>(url, {
      method: "GET",
      skipLoading: true,
    });
  },

  getChart: async (
    params: TDashboardChartRequest
  ): Promise<TDashboardChartResponse> => {
    // Monta o objeto de filtro como JSON (seguindo o padrão dos outros endpoints)
    const filterObj: { type_product?: string; year: string } = {
      year: String(params.year),
    };
    
    // Se for diferente de "all", adiciona o type_product no filtro
    if (params.type_product && params.type_product !== "all") {
      filterObj.type_product = params.type_product;
    }
    
    // Constrói a URL com query parameter filters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filterObj));
    
    const url = `${API_BASE}/product/chart?${queryParams.toString()}`;
    
    return customFetch<TDashboardChartResponse>(url, {
      method: "GET",
      skipLoading: true,
    });
  },

  getPlanChart: async (
    params: { year: number }
  ): Promise<TDashboardChartResponse> => {
    // Monta o objeto de filtro como JSON (apenas year para planos)
    const filterObj: { year: string } = {
      year: String(params.year),
    };
    
    // Constrói a URL com query parameter filters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filterObj));
    
    const url = `${API_BASE}/plan/chart?${queryParams.toString()}`;
    
    return customFetch<TDashboardChartResponse>(url, {
      method: "GET",
      skipLoading: true,
    });
  },
};

